import { createValidator, ErrorObject, maxLength, required, requiredRichText, richTextMaxLength } from 'util/validation'
import {
  agendamentoConsultaCompartilhadaValidator,
  agendamentoConsultaPresencialCuidadoCompartilhadoValidator,
} from 'view/agenda/cadastro-agendamento/validator-agenda'
import {
  AgendarConsultaCuidadoCompartilhadoFieldsModel,
  CondutaGroupRecord,
  DevolutivaCuidadoCompartilhadoFieldsModel,
  DiscussaoCasoFormModel,
  EnviarGarantiaAcessoCuidadoCompartilhadoFieldsModel,
  PerguntaCuidadoCompartilhadoFieldsModel,
  ReclassificarPrioridadeFormModel,
  ResponsavelCuidadoCompartilhado,
  SugestaoAgendamentoGrupoCuidadoCompartilhadoFieldsModel,
  TipoAgendamentoCuidadoCompartilhado,
  TrocaExecutanteCuidadoCompartilhadoFieldsModel,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

export const reclassificacaoPrioridadeValidator = createValidator<ReclassificarPrioridadeFormModel>({
  prioridade: [required],
})

export const devolutivaCuidadoCompartilhadoFieldValidator = createValidator<DevolutivaCuidadoCompartilhadoFieldsModel>({
  resposta: [requiredRichText, richTextMaxLength(1000)],
  conduta: [required],
})

export const perguntaCuidadoCompartilhadoFieldValidator = createValidator<PerguntaCuidadoCompartilhadoFieldsModel>({
  pergunta: [requiredRichText, richTextMaxLength(1000)],
})

export const trocaExecutanteCuidadoCompartilhadoFieldValidator = createValidator<
  TrocaExecutanteCuidadoCompartilhadoFieldsModel
>({
  motivo: [requiredRichText, richTextMaxLength(1000)],
  lotacao: [required],
})

export const sugestaoAgendamentoGrupoCuidadoCompartilhadoFieldValidator = createValidator<
  SugestaoAgendamentoGrupoCuidadoCompartilhadoFieldsModel
>({
  observacao: [requiredRichText, richTextMaxLength(1000)],
})

export const enviarGarantiaAcessoCuidadoCompartilhadoFieldValidator = createValidator<
  EnviarGarantiaAcessoCuidadoCompartilhadoFieldsModel
>({
  motivo: [required, maxLength(200)],
  tipoAgendamento: [required],
})

export const agendarConsultaCuidadoCompartilhadoFieldValidator = (now: Date) =>
  createValidator<AgendarConsultaCuidadoCompartilhadoFieldsModel>({}, (values, errors) => {
    if (values?.tipoAgendamento === TipoAgendamentoCuidadoCompartilhado.CONSULTA_COM_CIDADAO) {
      errors.consultaComCidadao = agendamentoConsultaPresencialCuidadoCompartilhadoValidator(now)(
        values.consultaComCidadao
      )
    }

    if (values?.tipoAgendamento === TipoAgendamentoCuidadoCompartilhado.CONSULTA_COMPARTILHADA) {
      errors.consultaCompartilhada = agendamentoConsultaCompartilhadaValidator(now, true)(values.consultaCompartilhada)
    }

    return errors
  })

export const discussaoCasoFormValidator = (responsavelCuidado: ResponsavelCuidadoCompartilhado, now: Date) => {
  const isExecutante = responsavelCuidado === 'EXECUTANTE'

  return createValidator<DiscussaoCasoFormModel>(
    {},
    (values: DiscussaoCasoFormModel, errors: ErrorObject<DiscussaoCasoFormModel>) => {
      const valueField: 'executanteFields' | 'solicitanteFields' = isExecutante
        ? 'executanteFields'
        : 'solicitanteFields'

      const fields = values?.[valueField]
      const condutaGroup = fields?.condutaGroup

      if (!errors[valueField]) {
        errors[valueField] = {}
      }

      const fieldErrors = errors[valueField] as ErrorObject<typeof fields>

      fieldErrors.condutaGroup = required(condutaGroup)

      if (condutaGroup) {
        const validator = CondutaGroupRecord[condutaGroup]?.validator?.(now)
        fieldErrors[condutaGroup] = validator?.(fields?.[condutaGroup])
      }

      return errors
    }
  )
}
